"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function SparklesTwo10Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Prefix" },
            react_1.default.createElement("path", { id: "Subtract", d: "M0.833252 7.06331C1.90816 6.92719 2.75963 6.07494 2.89401 5H2.931C3.06572 6.07766 3.92116 6.93149 4.99992 7.06432V7.10029C3.92048 7.2332 3.06463 8.08804 2.93075 9.16667H2.89426C2.76071 8.09075 1.90884 7.23751 0.833252 7.10131L0.833252 7.06331Z", fill: "#131416" }),
            react_1.default.createElement("path", { id: "Subtract_2", d: "M3.33325 3.30291C5.05617 3.08769 6.4217 1.7225 6.63697 0H6.69617C6.91144 1.72251 8.27698 3.08771 9.99992 3.30292V3.36209C8.27643 3.57737 6.91057 4.94337 6.69596 6.66667H6.63718C6.42257 4.94338 5.05673 3.57739 3.33325 3.36209L3.33325 3.30291Z", fill: "#5E30E3" })));
}
function SparklesTwo10(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(SparklesTwo10Svg, Object.assign({}, svgProps)));
}
exports.default = SparklesTwo10;
//# sourceMappingURL=SparklesTwo10.js.map